import { FC } from "react";

import { IPeopleBlockFormData, PeopleBlockStatus } from "Bands/types";
import { FormBuilder } from "shared/components";
import { IAPIState, IFormButtons, IAPIError } from "shared/types";

import { getFormFields } from "./formData";

interface PeopleFormProps {
  apiStatus?: IAPIState;
  error?: boolean | string;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  resetForm?: boolean;
  apiError?: IAPIError | null;
  excludeOptions?: string[] | undefined;
  handleSubmit: (data: IPeopleBlockFormData) => void;
  onStatusChange?: (status: PeopleBlockStatus | undefined) => void;
}

export const PeopleForm: FC<PeopleFormProps> = ({
  apiStatus,
  error,
  buttons,
  handleSubmit,
  defaultValues,
  resetForm,
  apiError,
  onStatusChange,
  excludeOptions = [],
}) => {
  return (
    <FormBuilder
      isSubmitting={apiStatus === IAPIState.pending}
      apiErrorMessage={error}
      fields={getFormFields(excludeOptions, onStatusChange)}
      onSubmit={handleSubmit}
      buttons={buttons}
      defaultValues={defaultValues}
      resetForm={resetForm}
      resetFormOnSubmit={false}
      style={{
        gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
      }}
      apiError={apiError}
    />
  );
};
